const NAV_LINKS = [
  { href: '#headlines', label: '热点头条' },
  { href: '#hotlist', label: '话题热榜' },
  { href: '#memes', label: '热梗盘点' },
  { href: '#scene', label: '假期现场' },
  { href: '#faq', label: '吃瓜指南' },
  { href: '#about', label: '关于本站' },
];

const SECTIONS = ['出行资讯', '文旅打卡', '娱乐八卦', '民生动态', '网络热梗'];

export default function Footer() {
  const go = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <footer className="border-t border-accent-200/60 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 pb-8 pt-12 md:px-6">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          {/* 品牌 */}
          <div className="lg:col-span-2">
            <a
              href="#top"
              onClick={(e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              className="flex cursor-pointer items-center gap-2"
            >
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 font-heading text-lg leading-none text-background-50">
                瓜
              </span>
              <span className="font-heading text-xl text-foreground-900">
                五一爆料
                <span className="ml-1 align-middle text-[10px] font-sans text-accent-600">· 吃瓜不迷路</span>
              </span>
            </a>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              汇总五一假期期间的热点事件与热门话题，从网络热议到现场见闻，
              帮你在信息爆炸的小长假里快速掌握大瓜和新闻盘点，轻松愉快地追热点。
            </p>
            <p className="mt-4 flex items-center gap-2 text-sm text-foreground-600">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-500 text-background-50">
                <i className="ri-mail-line"></i>
              </span>
              <a href="mailto:hello@wuyi-baoliao.example" className="cursor-pointer underline-offset-4 hover:underline">
                hello@wuyi-baoliao.example
              </a>
            </p>
          </div>

          {/* 快速导航 */}
          <nav aria-label="页脚导航">
            <h4 className="flex items-center gap-2 font-heading text-base text-foreground-900">
              <i className="ri-compass-3-line text-primary-500"></i>
              快速导航
            </h4>
            <ul className="mt-4 grid grid-cols-2 gap-x-2 gap-y-3">
              {NAV_LINKS.map((item) => (
                <li key={item.href}>
                  <button
                    type="button"
                    onClick={() => go(item.href)}
                    className="cursor-pointer whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </nav>

          {/* 栏目 */}
          <div>
            <h4 className="flex items-center gap-2 font-heading text-base text-foreground-900">
              <i className="ri-apps-2-line text-secondary-500"></i>
              覆盖栏目
            </h4>
            <ul className="mt-4 flex flex-col gap-3">
              {SECTIONS.map((s) => (
                <li key={s}>
                  <a href="#headlines" onClick={(e) => { e.preventDefault(); go('#headlines'); }} className="cursor-pointer text-sm text-foreground-600 transition-colors hover:text-accent-600">
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 text-center sm:flex-row sm:text-left">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 五一爆料 · 本站为热点内容资讯整理站，所有图文内容仅作盘点展示。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <span className="inline-flex items-center gap-1">
              <i className="ri-english-input text-sm"></i> zh-CN
            </span>
            <a
              href="mailto:hello@wuyi-baoliao.example"
              className="cursor-pointer transition-colors hover:text-primary-600"
            >
              意见反馈
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}